module.exports = __webpack_public_path__ + "static/media/elephant-eating.911b92d8.png";